export default __webpack_public_path__ + "static/media/lwd.7ae21b75.jpeg";